module.exports = __webpack_public_path__ + "static/media/DIBS.01460d5a.png";